import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface LoadingSkeletonProps {
  /** Layout preset to mimic the eventual content while a query is pending. */
  variant?: "chart" | "lines" | "card";
  /** Number of placeholder rows for the "lines" variant. */
  lines?: number;
  className?: string;
}

/** Pending-state placeholder, sized to the content it stands in for. */
export function LoadingSkeleton({ variant = "lines", lines = 3, className }: LoadingSkeletonProps) {
  if (variant === "chart") {
    return (
      <div className={cn("space-y-3", className)}>
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-[360px] w-full" />
      </div>
    );
  }

  if (variant === "card") {
    return (
      <div className={cn("space-y-3 rounded-lg border border-border p-4", className)}>
        <Skeleton className="h-5 w-1/3" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    );
  }

  return (
    <div className={cn("space-y-2", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="h-4 w-full" />
      ))}
    </div>
  );
}
